import { render, staticRenderFns } from "./PurchaseRecordMgmt.vue?vue&type=template&id=4171c632"
import script from "./PurchaseRecordMgmt.vue?vue&type=script&lang=js"
export * from "./PurchaseRecordMgmt.vue?vue&type=script&lang=js"
import style0 from "./PurchaseRecordMgmt.vue?vue&type=style&index=0&id=4171c632&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports